export default {"src":"/_next/static/media/waving-hand.1da6fc7a.gif","height":256,"width":256,"blurWidth":0,"blurHeight":0};